// @flow

import common from './locales/fr/common.json'

export const fr = { common }

export default fr
